export const LAUNCH_DATE = new Date("2027-05-12T09:00:00Z").getTime();

export const isLaunched = () => Date.now() >= LAUNCH_DATE;
